<!--
  --
  -- オプション選択シート
  --
  -->
<template>
  <c-base-sheet>
    <!-- ラベル -->
    <template #caption>{{option.name}}</template>

    <!-- 説明 -->
    <template #description>
      <span v-html="option.desc"/>
    </template>

    <!-- コンテンツ -->
    <template>
      <v-row>
        <!-- 数量入力 -->
        <v-col cols="6">
          <c-option-select :option="option" />
        </v-col>

        <!-- 写真 -->
        <v-col cols="6" v-if="option.image">
          <c-option-image :src="option.image" />
        </v-col>
      </v-row>
    </template>
  </c-base-sheet>
</template>

<script>
import CBaseSheet from '../CBaseSheet'
import COptionSelect from './COptionSelect'
import COptionImage from './COptionImge'

export default {
  name: 'COptionSheet',
  components: {
    CBaseSheet,
    COptionSelect,
    COptionImage
  },

  props: {
    option: {
      type: Object,
      required: true
    }
  }
}
</script>
